export default __webpack_public_path__ + "static/media/products-1-m.e9b6d4b6.webp";